import {RouteDefinition} from "../../../routes"
import {BackgroundSettingsScreen} from "./BackgroundSettingsScreen"
import {CustomIconTheme} from "./CustomIconTheme"
import {CustomMenu} from "./CustomMenu"
import {ScreenCleanerScreen} from "./ScreenCleanerScreen"
import {ScreenEditScreen} from "./ScreenEditScreen"
import {ControlSortingScreen} from "./SortingsMenu/Control"
import {LeftMenuSettingsRoutes} from './SortingsMenu/LeftMenu';
import {LeftMenuListScreen} from "./SortingsMenu/LeftMenu/LeftMenuListScreen";

export const CustomizationSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/custom-menu",
        component: CustomMenu
    },
    {
        routerLink: "/settings/custom-menu/customization",
        component: BackgroundSettingsScreen
    },
    {
        routerLink: "/settings/custom-menu/icon-theme",
        component: CustomIconTheme
    },
    {
        routerLink: "/settings/custom-menu/screen-set/:id",
        component: ScreenEditScreen
    },
    {
        routerLink: "/settings/custom-menu/screen-cleaner",
        component: ScreenCleanerScreen
    }, 
    {
        routerLink: "/settings/custom-menu/control-sorting/",
        component: ControlSortingScreen
    },
    {
        routerLink: "/settings/custom-menu/left-menu-sorting/",
        component: LeftMenuListScreen
    }
]